export default __webpack_public_path__ + "resources/icons/n312-a000.webp";